import { useMutation } from '@tanstack/react-query';
import { customFetchV2 } from '../services/custom-fetch-v2';

interface ReactivateDeviceRequest {
  deviceId: string;
  planId: string;
}

interface ReactivateDeviceResponse {}

/**
 * API call to update device profile.
 */
const reactivateDevice =
  async (request: ReactivateDeviceRequest): Promise<ReactivateDeviceResponse | null> => {
    const { deviceId, planId } = request;

    const response: any = await customFetchV2(`/api/v2/devices/${deviceId}/reactivate`, {
      method: 'POST',
      body: JSON.stringify({ planId }),
    });

    if (!response.ok) {
      throw new Error('Unable to reactivate device');
    }

    return {};
  };

const useReactivateDeviceMutation = () => {
  return useMutation({
    mutationFn: reactivateDevice,
    onSuccess: () => {
      // TODO: Would make sense to invalidate related queries in here.. just need
      // to get hold of device ID and device profile ID
    },
  });
};

/** Exports */
export { useReactivateDeviceMutation };
